import React from 'react';
import type { BankAccountFormatRuleRes } from '@dealstack/shared/lib/generated';
import { BankAccountVerificationScope } from './BankAccountVerificationScope.tsx';
import { AccountHolderField } from './childFieldsets/AccountHolderField/AccountHolderField.tsx';
import { CurrencyField } from './childFieldsets/CurrencyField/CurrencyField.tsx';
import { FormatRuleFieldset } from './childFieldsets/FormatRuleFieldset/FormatRuleFieldset.tsx';
import { IbanFieldset } from './childFieldsets/IbanFieldset/IbanFieldset.tsx';
import { ruleUsesClassicIbanForm } from './BankAccountForm.utils.ts';
import type { BankAccountVerifyFn } from './useBankAccountForm.types.ts';

interface Props {
	rule: BankAccountFormatRuleRes | null;
	verifyIdentifiers?: BankAccountVerifyFn;
}

export const EntryPathFields = ({ rule, verifyIdentifiers }: Props) => (
	<>
		<AccountHolderField />
		<CurrencyField />
		<BankAccountVerificationScope rule={rule} verifyIdentifiers={verifyIdentifiers}>
			{!rule || ruleUsesClassicIbanForm(rule) ? (
				<IbanFieldset />
			) : (
				<FormatRuleFieldset rule={rule} />
			)}
		</BankAccountVerificationScope>
	</>
);
